import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AbstractApi } from './abstract.api';
import { Pool } from './pool.api';
import { User } from './profil.api';
import { man } from 'ionicons/icons';
import { Company } from './company.api';

export interface Assistance {
  id?: string;
  pool?: Pool;
  user?: User;
  createdAt?: string;
  status?: 'pending' | 'terminate';
  company?: Company;
  assignedTo?: string;
  messages?: string;
  notes?: string;
  modelIdentifier?: string;
  step1?: string;
  step2?: string;
  step3?: string;
  step4?: string;
}
export interface AssistanceList {
  count: number;
  data: Assistance[];
}

export type AssistanceReport = {
  title: string;
  elements: AssistanceReport[] | AssistanceCase[];
};

export type AssistanceCase = {
  title: string;
  content: string;
  media?: string;
};

export type PostAssistance = {
  poolId: string;
  modelIdentifier: string;
  step1: string;
  step2: string;
  step3: string;
  step4: string;
  message: string;
};

@Injectable({
  providedIn: 'root',
})
export class AssistanceApi extends AbstractApi {
  public getAssistances(
    length = 20,
    offset = 0,
    search: string = '',
    order: string = 'createdAt',
    direction: string = 'ASC',
    company: string | null,
    assignedTo: string | null,
    status: string | null = null,
  ): Promise<AssistanceList> {
    let params: any = {
      length: length,
      offset: offset,
      search: search,
      order: order,
      direction: direction,
    };

    if (assignedTo != null) {
      params.assignedTo = assignedTo;
    }

    if (company != null) {
      params.company = company;
    }

    if (status !== null) {
      params.status = status;
    }

    return firstValueFrom(
      this.http.get<AssistanceList>(
        `${this.backend}/api/v1/assistance/requests`,
        {
          params: params,
        },
      ),
    );
  }

  public patchAssistance(
    assitanceId: string,
    assistance: Assistance,
  ): Promise<Assistance> {
    return firstValueFrom(
      this.http.patch<Assistance>(
        `${this.backend}/api/v1/assistance/requests/${assitanceId}`,
        assistance,
      ),
    );
  }

  public transferAssistance(
    assitanceId: string,
    assistance: Assistance,
  ): Promise<Assistance> {
    return firstValueFrom(
      this.http.patch<Assistance>(
        `${this.backend}/api/v1/assistance/requests/${assitanceId}/transfer`,
        assistance,
      ),
    );
  }

  public getProductAssistance(
    manufacturerName: string,
    modelIdentifier: string,
    version: number,
  ): Promise<AssistanceReport[]> {
    return firstValueFrom(
      this.http.get<AssistanceReport[]>(
        `${this.backend}/api/v1/assistance/${manufacturerName}/${modelIdentifier}/${version}`,
      ),
    );
  }

  public deleteAssistance(assitanceId: string): Promise<Assistance> {
    return firstValueFrom(
      this.http.delete<Assistance>(
        `${this.backend}/api/v1/assistance/requests/${assitanceId}`,
      ),
    );
  }
}
